module.exports = __webpack_public_path__ + "img/screen-home-options.478273c5.jpg";